import { getCookie } from '@/presentation/libs/cookie.lib';
import { getRoleFromAccessToken, getRolesFromAccessToken } from '@/presentation/router/defaultRoute.router';
import useSharedStore from '@/presentation/store/shared';

export const getRoleRouteRedirect = (meta: Record<string, any>, role?: string | null, _roles?: string[]) => {
	const allowedRoles = Array.isArray(meta?.allowedRoles) ? meta.allowedRoles : [];
	const blockedRoles = Array.isArray(meta?.blockedRoles) ? meta.blockedRoles : [];

	// Backend authorization uses the active role claim. Other roles listed in the
	// token are only available contexts and require an explicit context switch.
	if (allowedRoles.length && (!role || !allowedRoles.includes(role))) return { name: 'Forbidden' };
	if (blockedRoles.includes(role)) return { name: 'Home' };
	return true;
};

const roleMiddleware = (router) => {
	router.beforeEach((to) => {
		const sharedStore = useSharedStore();
		const token = getCookie('access-token');
		const role = getRoleFromAccessToken(token) || sharedStore.userInformation?.role;
		const roles = getRolesFromAccessToken(token) || sharedStore.userInformation?.roles || (role ? [role] : []);
		return getRoleRouteRedirect(to.meta, role, roles);
	});
};

export default roleMiddleware;
